import { IActionFn } from '@/store/types';
import { IDetail, IModuleState } from './types';
import { $http } from '@/axios';
import router from '@/plugins/router';
import store from '@/store';

// 查询属性列表
export const queryProperties: IActionFn<IModuleState> = async ({ commit, state }, payload) => {
  try {
    commit('setProperties', { ...state.list, loading: true });
    // const res = await $http.get('/baseinfo/property/get', payload);
    const res = await $http.get('/v1/baseinfo/attribute/list', payload);
    commit('setProperties', { data: res, loading: false });
  } catch (e) {
    commit('setProperties', { data: [], loading: false });
  }
};

// 查询属性详情
export const queryPropertyDetail: IActionFn<IModuleState> = async ({ commit, state }, payload) => {
  try {
    commit('setPropertyDetail', { data: null, loading: true });
    commit('setPropertyOptions', { ...state.options, loading: true  });
    // const res: IDetail['data'] = await $http.get(`/baseinfo/property/detail/${payload}`);
    const res: IDetail['data'] = await $http.get(`/v1/baseinfo/attribute/${payload}/detail`);
    commit('setPropertyDetail', { data: res });
    commit('setPropertyOptions', { data: res?.options || [] });
  } catch (e) {
    commit('setPropertyDetail', { data: null });
    commit('setPropertyOptions', { data: [] });
  }
};

// 添加属性
export const addProperty: IActionFn<IModuleState> = async ({ commit, state }, payload) => {
  try {
    commit('setLoading', true);
    // await $http.post('/baseinfo/property/create', payload);
    await $http.post('/v1/baseinfo/attribute/create', payload);
    store.commit('common/setToast', { visible: true, text: '添加成功' });
    await router.push({ name: 'baseinfo-property' });
  } finally {
    commit('setLoading', false);
  }
};

// 编辑属性
export const editProperty: IActionFn<IModuleState> = async ({ commit }, payload) => {
  try {
    commit('setLoading', true);
    // await $http.post('/baseinfo/property/modify', payload);
    await $http.post('/v1/baseinfo/attribute/modify', payload);
    store.commit('common/setToast', { visible: true, text: '编辑成功' });
  } finally {
    commit('setLoading', false);
  }
};

// 删除属性
export const deleteProperty: IActionFn<IModuleState> = async ({ commit, dispatch, state }, payload) => {
  try {
    commit('setConfirm', { ...state.confirm, loading: true });
    // await $http.post('/baseinfo/property/delete', payload);
    await $http.post('/v1/baseinfo/attribute/delete', payload);
    await dispatch('queryProperties');  // 重新查询类别
  } finally {
    commit('setConfirm', { visible: false });
  }
};

// 添加属性选项
export const addOption: IActionFn<IModuleState> = async ({ commit, state }, payload) => {
  try {
    commit('setDialog', { ...state.dialog, loading: true });
    // await $http.post('/baseinfo/property/option/add', payload);
    await $http.post('/v1/baseinfo/attribute/addoption', payload);
    store.commit('common/setToast', { visible: true, text: '属性选项添加成功' });
  } finally {
    commit('setDialog', { visible: false });
  }
};

// 编辑属性选项
export const editOption: IActionFn<IModuleState> = async ({ commit, state }, payload) => {
  try {
    commit('setDialog', { ...state.dialog, loading: true });
    // await $http.post('/baseinfo/property/option/modify', payload);
    await $http.post('/v1/baseinfo/attribute/modifyoption', payload);
    store.commit('common/setToast', { visible: true, text: '属性选项编辑成功' });
  } finally {
    commit('setDialog', { visible: false });
  }
};

// 删除属性选项
export const deleteOption: IActionFn<IModuleState> = async ({ commit, state }, payload) => {
  try {
    commit('setConfirm', { ...state.confirm, loading: true });
    // await $http.post('/baseinfo/property/option/delete', payload);
    await $http.post('/v1/baseinfo/attribute/deleteoption', payload);
  } finally {
    commit('setConfirm', { visible: false });
  }
};
